import { Link } from "react-router-dom";
import { LOGO } from "@/lib/api";
import { Instagram } from "lucide-react";
import { toast } from "sonner";

export const Footer = () => {
  const onSubscribe = (e) => {
    e.preventDefault();
    e.target.reset();
    toast.success("You're in. Welcome to the squad.");
  };
  return (
    <footer className="bg-ink text-cream" data-testid="footer">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <img src={LOGO} alt="Rock Hard Tennis" className="h-20 w-20 object-contain mb-4" />
          <p className="text-cream/60 text-sm leading-relaxed max-w-xs">
            Tennis gear with attitude. Built for players who swing hard and never back down.
          </p>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest mb-5">Shop</h4>
          <ul className="space-y-3 text-sm text-cream/70">
            <li><Link to="/shop/men" className="hover:text-sale transition-colors">Men</Link></li>
            <li><Link to="/shop/women" className="hover:text-sale transition-colors">Women</Link></li>
            <li><Link to="/shop/accessories" className="hover:text-sale transition-colors">Accessories</Link></li>
            <li><Link to="/shop/all" className="hover:text-sale transition-colors">Shop All</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest mb-5">Help</h4>
          <ul className="space-y-3 text-sm text-cream/70">
            <li><Link to="/shipping" className="hover:text-sale transition-colors" data-testid="footer-shipping">Shipping</Link></li>
            <li><Link to="/contact" className="hover:text-sale transition-colors" data-testid="footer-contact">Contact Us</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest mb-5">Join the squad</h4>
          <p className="text-sm text-cream/60 mb-4">Sign up for new drops and court-side chaos.</p>
          <form onSubmit={onSubscribe} className="flex border-b border-cream/30" data-testid="newsletter-form">
            <input type="email" required placeholder="Email address" data-testid="newsletter-input"
              className="bg-transparent flex-1 py-2 text-sm focus:outline-none placeholder:text-cream/40" />
            <button type="submit" className="text-xs font-bold uppercase tracking-widest" data-testid="newsletter-submit">Join</button>
          </form>
          <div className="flex gap-4 mt-6">
            <a href="https://instagram.com/rockhardtennis" target="_blank" rel="noopener noreferrer" aria-label="Instagram @rockhardtennis" data-testid="footer-instagram" className="text-cream/70 hover:text-sale transition-colors">
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-cream/10 py-6 text-center text-xs text-cream/40 uppercase tracking-widest">
        © {new Date().getFullYear()} Rock Hard Tennis Gear — All Rights Reserved
      </div>
    </footer>
  );
};
